<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-edit-form`]" width="1em" height="1em" v-bind="$attrs"><rect x="2.299" y="3.528" width="18.174" height="18.174" rx="6" :fill="useCurrentColor ? 'currentColor' : '#BEDAFF'"/><path d="M18.1311 2.15502C18.543 1.74316 18.7489 1.53724 18.961 1.41025C19.5935 1.03162 20.383 1.03162 21.0155 1.41025C21.2277 1.53724 21.4336 1.74316 21.8454 2.15502C22.2573 2.56687 22.4632 2.7728 22.5902 2.98494C22.9688 3.61743 22.9688 4.40693 22.5902 5.03942C22.4632 5.25157 22.2573 5.45749 21.8454 5.86935L15.8786 11.8361C15.3132 12.4016 15.0305 12.6843 14.7056 12.9021C14.4173 13.0953 14.1051 13.2502 13.7768 13.3628C13.4069 13.4898 13.0107 13.5438 12.2184 13.6519L11.0963 13.805C10.7418 13.8534 10.5646 13.8775 10.435 13.8201C10.3214 13.7698 10.2306 13.679 10.1803 13.5655C10.1229 13.4359 10.1471 13.2586 10.1955 12.9042L10.3486 11.7821C10.4567 10.9898 10.5107 10.5936 10.6376 10.2237C10.7503 9.89539 10.9052 9.58319 11.0984 9.2949C11.3161 8.97001 11.5989 8.68728 12.1643 8.12182L18.1311 2.15502Z" :fill="useCurrentColor ? 'currentColor' : '#165DFF'"/></svg>
</template>
<script>

export default {
  name: 'IconColorEditForm',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
